import { render, staticRenderFns } from "./SliderBlog.vue?vue&type=template&id=5343f54f"
import script from "./SliderBlog.vue?vue&type=script&lang=js"
export * from "./SliderBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports